import React from 'react';
import { Link } from 'react-router-dom';

function Breadcrumb({ crumbs, children }) {
  return (
    <div className="breadcrumb">
      {crumbs.map(
        (crumb, i) =>
          crumb.to ? (
            <Link key={`bread-crumb-${i}`} to={crumb.to} className="breadcrumb__link">
              <span>{crumb.label}</span>
            </Link>
          ) : (
            <div className="breadcrumb__current" key={`bread-crumb-${i}`}>
              <span>{crumb.label}</span>
            </div>
          )
      )}
      {children}
    </div>
  );
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/common/components/Breadcrumb.js